export enum InsuranceProductTypes {
  PERSONAL_ACCIDENT = 1,
  HOME_INSURANCE = 2,
  CAR_INSURANCE = 3,
  MEDICAL_INSURANCE = 4,
  FIRE_THEFT_INSURANCE = 5,
}
